import React, { useEffect  } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import styled from 'styled-components'
import NotifItem from './NotifItem'
import { getNotifications } from 'features/notifs/notifSlice'
import Loader from "loaders/Loader";
import NotificationsNoneIcon from '@mui/icons-material/NotificationsNone';
import { useTranslation } from 'react-i18next'

export default function NotifFeed() {
    const dispatch = useDispatch()
    const { t } = useTranslation('notifications')

    const { allNotifications, getNotificationsStatus } = useSelector((state) => state.notifications)

    useEffect(() => {  
        dispatch(getNotifications({
            markRead: true,
            exclued: "messages"
        })) 
    }, [dispatch])
        
    return (
        <NotifFeedContainer>
        {

            getNotificationsStatus === "LOADING" ?
            (
                <LoadingWrap>
                    <Loader />
                </LoadingWrap>
            )
            : getNotificationsStatus === "SUCCESS" && allNotifications.length > 0 ?
            (
                <NotificationList>
                    {[...allNotifications]
                    .sort((a, b) => new Date(b.createdAt) - new Date(a.createdAt))
                    .map((notif, index) => (
                        <NotifItem key={notif._id} index={index} data={notif} />
                    ))}
                </NotificationList>
            )
            :
            (
                <EmptyState>
                    <EmptyIconWrap>
                        <NotificationsNoneIcon />
                    </EmptyIconWrap>
                    <EmptyTitle>{t('emptyTitle')}</EmptyTitle>
                    <EmptyCopy>{t('emptyBody')}</EmptyCopy>
                </EmptyState>
            )
        }
        </NotifFeedContainer>
  )
}

const NotifFeedContainer = styled.div`
    display: flex;
    flex-direction: column;
    align-items: stretch;
    justify-content: flex-start;
    width: 100%;
    height: 100%;
    min-height: 0;
    overflow-y: auto;
    padding: 14px;

    @media (max-width: 768px) {
        padding: 10px;
    }
`

const NotificationList = styled.div`
    width: 100%;
    display: flex;
    flex-direction: column;
    gap: 8px;
`

const LoadingWrap = styled.div`
    min-height: 260px;
    display: flex;
    align-items: center;
    justify-content: center;
`

const EmptyState = styled.div`
    min-height: 320px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    text-align: center;
    color: var(--lightThemeFontColor);
    padding: 32px 20px;
`

const EmptyIconWrap = styled.div`
    width: 58px;
    height: 58px;
    border-radius: 50%;
    background: rgba(0, 180, 204, 0.1);
    color: var(--themeColor);
    display: flex;
    align-items: center;
    justify-content: center;
    margin-bottom: 14px;

    svg {
        font-size: 30px;
    }
`

const EmptyTitle = styled.div`
    font-family: 'Roboto', sans-serif;
    font-size: 16px;
    font-weight: 600;
    margin-bottom: 6px;
`

const EmptyCopy = styled.p`
    margin: 0;
    max-width: 320px;
    font-family: 'Roboto', sans-serif;
    font-size: 13px;
    line-height: 1.45;
    color: var(--dFontColor);
`
